import { pushGA4Event } from "./helpers";

const byEventName = (eventDetails) => {
  const { eventName } = eventDetails;

  if (!eventName) {
    return;
  }

  if (Object.keys(eventDetails).length === 1) {
    pushGA4Event({ eventName });
    return;
  }

  switch (eventName) {
    case "sort_results_by":
      let { sort_by: sortByData } = eventDetails;

      sortByData = sortByData?.replace("sort-by-", "").replace(/-/g, "_") || null;

      if (sortByData) {
        pushGA4Event({ eventName, eventData: { sort_by: sortByData } });
      }

      break;
    case "open_video_fullscreen": 
    case "open_photo_fullscreen":
    case "more_details_link":
    case "more_details_info_icon":
      let { view_type: viewData } = eventDetails;
      
      viewData = viewData?.replace("s-tab", "") || null;
      
      if (viewData) {
        pushGA4Event({ eventName, eventData: { view_type: viewData } });
      }

      break;
    case "select_room": 
    case "select_rate":
    case "select_package":
      let { view_type: selectData } = eventDetails;

      if (selectData.endsWith('s')) {
        selectData = selectData.slice(0, -1);
      }
      
      if (selectData) {
        pushGA4Event({ eventName, eventData: { view_type: selectData } });
      }

      break;
    default:
      delete eventDetails.eventName;

      if (Object.keys(eventDetails).length > 0) {
        pushGA4Event({ eventName: eventName, eventData: eventDetails });
      }

      break;
  }
};

const BE5EventListener = () => {
  document.addEventListener("EVT_AMA_HOS_GTM_CUSTOM_EVENT", (e) => {
    if (e?.detail) {
      byEventName(e.detail);
    }
  });
};

export { BE5EventListener };
